import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const fallbackLng = 'en-US';
const supportedLngs = ['fr-FR', 'en-US', 'en-GB', 'es-ES', 'it-IT', 'de-DE', 'zh-CN'];

// Define namespaces for lazy loading
const defaultNS = 'common';
const _namespaces = [
  'common',      // Default namespace (always loaded)
  'labels',      // UI labels and form fields
  'shared',      // Small modules merged together
  'transport',   // Transport/shipping management
  'inventory',   // Inventory management
  'manager',     // Manager features
  'marketing',   // Marketing features
  'business',    // Business logic
  'components',  // UI components
  'auth',        // Authentication
  'theme',       // Theme customization
];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng,
    supportedLngs,
    load: 'currentOnly',
    
    // Namespace configuration - preload common and shared namespaces
    ns: [defaultNS, 'shared'], // Load 'common' and 'shared' initially
    defaultNS,
    
    interpolation: { 
      escapeValue: true // XSS protection enabled
    },
    
    backend: {
      // New path pattern for namespace-based files
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      requestOptions: {
        cache: 'default',
      },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'wms-user-locale',
      caches: ['localStorage'],
    },
    react: {
      // Disabled to prevent TDZ errors when components use useTranslation
      // before i18n is fully initialized during module evaluation
      useSuspense: false,
    },
  });

export default i18n;
